import { SemanticTokens } from '@/core/tokens/designs/types';
import { primitiveRadius } from '../primitives/radius';

export interface ComponentTokens {
	Card: {
		background: string;
		backgroundHover: string;
		border: string;
		text: string;
		shadow: string;
		radius?: string;
	};
	Button: {
		primary: { background: string; backgroundHover: string; text: string; border: string };
		secondary: { background: string; backgroundHover: string; text: string; border: string };
		radius?: string;
	};
	Input: {
		background: string;
		border: string;
		borderFocus: string;
		text: string;
		placeholder: string;
		radius?: string;
	};
	AccordionItem: {
		background: string;
	};
}

/** Стили компонентов, общие для light/dark — один раз на дизайн */
export const componentStyles: Partial<Record<keyof ComponentTokens, Record<string, string>>> = {
	Button: { radius: primitiveRadius.full },
	Card: { radius: primitiveRadius.lg },
	Input: { radius: primitiveRadius.sm },
};

export const createComponentTokensLight = (semantic: SemanticTokens): ComponentTokens => ({
	Card: {
		background: semantic.surface.background,
		backgroundHover: semantic.interactive.hover,
		border: semantic.border.subtle,
		text: semantic.text.primary,
		shadow: semantic.elevation.raised,
	},
	Button: {
		primary: {
			background: semantic.status.info,
			backgroundHover: semantic.interactive.pressed,
			text: semantic.surface.primary,
			border: 'transparent',
		},
		secondary: {
			background: semantic.surface.secondary,
			backgroundHover: semantic.interactive.hover,
			text: semantic.text.primary,
			border: semantic.border.default,
		},
	},
	Input: {
		background: semantic.surface.primary,
		border: semantic.border.default,
		borderFocus: semantic.status.info,
		text: semantic.text.primary,
		placeholder: semantic.text.tertiary,
	},
	AccordionItem: {
		background: semantic.surface.secondary,
	},
});

export const createComponentTokensDark = (semantic: SemanticTokens): ComponentTokens => ({
	Card: {
		background: semantic.surface.tertiary,
		backgroundHover: semantic.interactive.hover,
		border: semantic.border.subtle,
		text: semantic.text.primary,
		shadow: semantic.elevation.raised,
	},
	Button: {
		primary: {
			background: semantic.status.info,
			backgroundHover: semantic.interactive.pressed,
			text: semantic.surface.background,
			border: 'transparent',
		},
		secondary: {
			background: semantic.surface.secondary,
			backgroundHover: semantic.interactive.hover,
			text: semantic.text.primary,
			border: semantic.border.default,
		},
	},
	Input: {
		background: semantic.surface.secondary,
		border: semantic.border.default,
		borderFocus: semantic.status.info,
		text: semantic.text.primary,
		placeholder: semantic.text.tertiary,
	},
	AccordionItem: {
		background: semantic.surface.tertiary,
	},
});
